export default "__VITE_ASSET__843f1eab__"